<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{$t('Ga terug')}}
                        </ak-button>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                <i class="fa fa-list-ul"></i> {{ $t('Kandidaat-fiche') }}
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <tbody>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Datum aanvraag') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.dateCreated | date-relative }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('BTW-nummer') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.vat }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Naam van de organisatie') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.title }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Publieke naam') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.titlePublic }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Adresgegevens van de zaak') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.address }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Website') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a v-if="candidate.website" :href="candidate.website" target="_blank">
                                            {{ candidate.website }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('E-mailadres') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a v-if="candidate.email" :href="`mailto:${candidate.email}`" target="_blank">
                                            {{ candidate.email }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Publiek e-mailadres') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a v-if="candidate.emailPublic" :href="`mailto:${candidate.emailPublic}`" target="_blank">
                                            {{ candidate.emailPublic }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Type handelaar') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.typeTitle }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Categorie') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ collection ? collection.title : '' }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Motivatie') }}:</i>
                                    </td>
                                    <td class="ak-table-column" v-html="candidate.motivation.replace(/(?:\r\n|\r|\n)/g, '<br>') ">
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Andere kortingssites?') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ candidate.otherWebsitesForDisplay }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <i class="muted">{{ $t('Bestand') }}:</i>
                                    </td>
                                    <td class="ak-table-column">
                                        <a v-if="candidate.uploadFilePath" :href="candidate.uploadFilePath" target="_blank">
                                            {{ $t('Download bestand') }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info  ak-panel__header--small">
                            <div class="ak-panel__title">
                                <i class="fa fa-certificate"></i> {{ $t('Exclusief voordeel') }}
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <tbody>
                                <tr v-for="offer in offers" :key="offer.id" class="ak-table-row">
                                    <td class="ak-table-column">
                                        <ak-chip
                                            :title="$options.filters.datetime(offer.dateCreated)"
                                            size="small"
                                        />
                                        <p class="p-1" v-html="offer.offer.replace(/(?:\r\n|\r|\n)/g, '<br>')">
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div :class="`ak-panel__header ak-panel__header--small candidate-status candidate-status-${candidate.status}`" style=":root {--panel-header-background: red;}">
                            <div class="ak-panel__title">
                                {{ candidate.statusTitle }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small">
                            <ak-button
                                :title="ratingAdministrator ? $t('Beoordeling aanpassen') : $t('Beoordeling toevoegen')"
                                size="small"
                                colorMode="secondary"
                                @click="onClickRatingButton"
                            />
                            <template>
                                <ak-button
                                    :title="$t('Beslissing ingeven')"
                                    size="small"
                                    colorMode="secondary"
                                    @click="onClickDecisionButton"
                                />
                                <ak-button
                                    v-if="supplier"
                                    :title="$t('Bekijk leverancier')"
                                    size="small"
                                    colorMode="secondary"
                                    @click="onClickViewSupplierButton"
                                />
                                <ak-button
                                    v-else
                                    :title="$t('Leverancier aanmaken')"
                                    size="small"
                                    colorMode="secondary"
                                    @click="onClickCreateSupplierButton"
                                />
                            </template>
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                <i class="fa fa-star"></i> {{ $t('Beoordelingen') }}
                            </div>
                        </div>
                        <table v-if="!loading && ratings.length" class="ak-table ak-panel__table">
                            <tbody>
                                <tr class="ak-table-column">
                                    <th class="ak-table-column">{{ $t('Datum') }}</th>
                                    <th class="ak-table-column">{{ $t('Beheerder') }}</th>
                                    <th class="ak-table-column">{{ $t('Handelaar') }}</th>
                                    <th class="ak-table-column">{{ $t('Exclusief voordeel') }}</th>
                                </tr>
                                <tr v-for="rating in ratings" :key="rating.id" class="ak-table-column">
                                    <td class="ak-table-column">
                                        {{ rating.dateCreated | date }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ rating.administratorName }}
                                    </td>
                                    <td class="ak-table-column">

                                        <ak-tooltip
                                            :disabled="rating.commentsCandidate"
                                            :body="rating.commentsCandidate"
                                        >
                                            <span
                                                :class="`rating-candidate-${rating.administratorId}`"
                                                v-html="rating.ratingCandidateAsHtml" />
                                        </ak-tooltip>
                                    </td>
                                    <td class="ak-table-column">
                                        <ak-tooltip
                                            :disabled="rating.commentsOffer"
                                            :body="rating.commentsOffer"
                                        >
                                            <span
                                                :class="`rating-candidate-${rating.administratorId}`"
                                                v-html="rating.ratingOfferAsHtml" />
                                        </ak-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else class="ak-panel__body ak-panel__body--small">
                            {{ $t('Nog geen beoordelingen') }}
                        </div>
                    </div>
                    <div v-if="!loading && ratings.length" class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--info ak-panel__header--small">
                            <div class="ak-panel__title">
                                <i class="fa fa-history"></i> {{ $t('Historiek') }}
                            </div>
                        </div>
                        <table class="ak-table ak-panel__table">
                            <tbody>
                                <tr class="ak-table-column">
                                    <th class="ak-table-column">{{ $t('Datum') }}</th>
                                    <th class="ak-table-column">{{ $t('Beheerder') }}</th>
                                    <th class="ak-table-column">{{ $t('Omschrijving') }}</th>
                                </tr>
                                <tr v-for="historyItem in history" :key="historyItem.id" class="ak-table-column">
                                    <td class="ak-table-column">
                                        {{ historyItem.dateCreated | datetime }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ historyItem.administratorName }}
                                    </td>
                                    <td class="ak-table-column" v-html="historyItem.description" />
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <router-view
            name="childview"
            @formSaved="onFormSaved"
        />
    </div>
</template>

<script>
export default {
    name: 'SupplierCandidateOverview',
    data() {
        return {
            candidate: null,
            ratings: null,
            history: null,
            offers: null,
            supplier: null,
            collection: null,
            ratingAdministrator: null,
            loading: false,
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/supplier-candidate-overview/' + this.$route.params.hashId);
            if (result.success) {
                this.candidate = result.data.candidate;
                this.ratings = result.data.ratings;
                this.history = result.data.history;
                this.offers = result.data.offers;
                this.supplier = result.data.supplier;
                this.collection = result.data.collection;
                this.ratingAdministrator = result.data.ratingAdministrator;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({
                name: 'grid',
                params: {
                    bundle: 'supplier-candidate',
                    gridDefinition: 'grid'
                }
            });
        },
        onClickRatingButton() {
            this.$router.push({
                name: 'supplier-candidate-form',
                params: {
                    bundle: 'supplier-candidate-rating',
                    hashId: this.candidate.hashId,
                    definition: 'form',
                    objectId: 'new'
                },
                query: {
                    candidateId: this.candidate.hashId
                }
            });
        },
        onClickDecisionButton() {
            this.$router.push({
                name: 'supplier-candidate-form',
                params: {
                    bundle: 'supplier-candidate',
                    hashId: this.candidate.hashId,
                    definition: 'decision-form',
                    objectId: this.candidate.hashId
                },
            });
        },
        onClickViewSupplierButton() {
            this.$router.push({
                name: 'supplier-candidate-form',
                params: {
                    bundle: 'supplier',
                    hashId: this.candidate.hashId,
                    definition: 'form',
                    objectId: this.supplier.hashId
                },
                query: {
                    candidateOverview: true
                }
            });
        },
        onClickCreateSupplierButton() {
            this.$router.push({
                name: 'supplier-candidate-form',
                params: {
                    bundle: 'supplier',
                    hashId: this.candidate.hashId,
                    definition: 'create-form',
                    objectId: 'new'
                },
                query: {
                    candidateOverview: true,
                    candidateId: this.candidate.hashId
                }
            });
        },
        onFormSaved() {
            this.initialize();
            this.$router.push({ name: 'supplier-candidate-overview'});
        }
    },
    created() {
        this.initialize();
    }
}
</script>
